import React from 'react'
import useInput from 'tennders-common/form/hooks/useInput'
import ReactTooltip from 'react-tooltip'
import stylesInput from '@/styles/Input.module.scss'
import IconInfo from '../../../../../icons/icon-gen-info.svg'

type Props = {
  className?: string
  labelClassName?: string
  label?: string
  errors?: Record<string, any>
  form?: Record<string, any>
  name?: string
  required?: boolean
  disabled?: boolean
  onChange?: (key: string, value: any) => void
  renderInput?: (any) => JSX.Element
  infoTooltip?: string
}

const InputLabeledContainer = (props: Props) => {
  const {
    className = '',
    labelClassName = 'form-label',
    label = '',
    errors,
    form,
    name,
    required,
    disabled,
    onChange,
    renderInput,
    infoTooltip
  } = props
  const { errorContent, errorText, value, onSet } = useInput({
    errors,
    form,
    name,
    onChange
  })

  return (
    <div className={className}>
      <label className={`d-flex align-center ${labelClassName}`}>
        {' '}
        {label}
        {required && <span className={stylesInput.required}>*</span>}
        {infoTooltip && (
          <span className="d-flex align-center">
            <IconInfo data-tip data-for={name + '1'} />
            <ReactTooltip id={name + '1'} className="custom-color-tooltip" type="info">
              {infoTooltip}
            </ReactTooltip>
          </span>
        )}
        {errorContent}
      </label>
      {renderInput({ error: errorText, name, onSet, value, disabled, required })}
    </div>
  )
}

export default React.memo<Props>(InputLabeledContainer)
